module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-19-865cc114587f7f97c4c4aaf7b4453b1d.jpg";